<template>
    <div
        v-click-outside="closeDropdown"
        class="relative"
        :class="compact ? 'inline-block' : 'w-full'"
    >
        <label
            v-if="label"
            class="block mb-1 text-sm text-theme-muted font-semibold"
            :class="{ 'font-bold': labelBold }"
        >
            {{ label }}
        </label>
        <button
            ref="trigger"
            type="button"
            class="flex items-center justify-between rounded-md border bg-theme-input text-theme-base text-left transition-colors focus:outline-none focus:ring-1"
            :class="[
                compact
                    ? 'min-w-32 gap-1.5 px-2.5 py-1.5 text-xs'
                    : 'w-full mt-1 px-3 py-2 text-sm',
                error
                    ? 'border-theme-danger focus:ring-theme-danger'
                    : 'border-theme-border focus:ring-theme-primary',
                disabled
                    ? 'opacity-80 cursor-not-allowed text-theme-disabled'
                    : ''
            ]"
            :disabled="disabled"
            @click="toggleOpen"
            @focus="$emit('focus')"
            @blur="$emit('blur')"
            @keydown.down.prevent="onArrowDown"
            @keydown.up.prevent="onArrowUp"
            @keydown.enter.prevent="onEnter"
            @keydown.esc="onEscape"
        >
            <span class="flex min-w-0 items-center gap-1.5">
                <span v-if="$slots.prefix" class="flex-shrink-0">
                    <slot name="prefix"></slot>
                </span>
                <span :class="!selectedLabel ? 'text-theme-muted' : ''">
                    {{ selectedLabel || placeholder }}
                </span>
            </span>
            <span class="ml-2 flex-shrink-0 text-theme-muted">▾</span>
        </button>
        <div
            v-if="open"
            ref="panel"
            class="z-600 rounded-md border border-theme-border bg-theme-card shadow-lg"
            :style="dropdownStyle"
        >
            <div
                v-if="mode === 'search'"
                class="p-2 border-b border-theme-border"
            >
                <input
                    v-model="query"
                    type="text"
                    class="w-full rounded border border-theme-border bg-theme-input px-2 py-1 text-sm text-theme-base focus:outline-none"
                    placeholder="Buscar..."
                    @keydown.down.prevent="onArrowDown"
                    @keydown.up.prevent="onArrowUp"
                    @keydown.enter.prevent="onEnter"
                    @keydown.esc="onEscape"
                />
            </div>
            <div class="max-h-60 overflow-auto">
                <button
                    v-for="(option, index) in filteredOptions"
                    :key="option.value"
                    type="button"
                    class="w-full text-left px-3 py-2 text-sm text-theme-base hover:bg-theme-hover"
                    :class="{
                        'bg-theme-hover': index === highlightedIndex,
                        'font-semibold': isSelected(option)
                    }"
                    @click="selectOption(option)"
                >
                    {{ option.label }}
                </button>
                <div
                    v-if="!filteredOptions.length"
                    class="px-3 py-2 text-sm text-theme-muted"
                >
                    Sin resultados
                </div>
            </div>
        </div>
        <p v-if="error" class="mt-1 text-xs text-theme-danger">
            {{ error }}
        </p>
    </div>
</template>

<script>
import customSelectDropdownMixin from "@/mixins/customSelectDropdownMixin";
import ClickOutside from "vue-click-outside";

export default {
    name: "CustomSimpleSelect",
    directives: {
        ClickOutside
    },
    mixins: [customSelectDropdownMixin],
    model: {
        prop: "value",
        event: "input"
    },
    props: {
        value: {
            default: () => "",
            type: [String, Number],
            required: false
        },
        compact: {
            default: () => false,
            type: Boolean,
            required: false
        }
    },
    emits: ["input", "change", "focus", "blur"],
    computed: {
        selectedLabel() {
            const found = this.options.find(
                (option) => option.value === this.value
            );
            if (found) {
                return found.label;
            }
            return this.value === null || this.value === undefined ? "-" : "";
        }
    },
    methods: {
        isSelected(option) {
            return option.value === this.value;
        },
        selectOption(option) {
            this.$emit("input", option.value);
            this.$emit("change", option.value);
            this.closeDropdown();
        }
    }
};
</script>
